import styled from "styled-components";

export const Svg = styled.svg`
  path {
    transition:
      fill 0.2s,
      stroke 0.2s;
  }
`;
